import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dropdown, Modal, Button, Form } from "react-bootstrap";
import CreateSalesPlanModal from "./CreateSalesPlanModal";
import {
  getSalesPlanStart,
  deleteSalesPlanStart,
  getMainSalesPlanStart,
  deleteMainSalesPlanStart
} from "../../../Store/Slices/salesPlanSlice";
import { Utils } from "../../../Utils";

const currentYear = new Date().getFullYear();
const pastYears = 2;
const futureYears = 1;

function getMonthName(month) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthNames[month - 1];
}

const getOptions = (
  type,
  salesPlanPeriodType,
  salesPlanCalculation,
  selectedPlan
) => {
  const groupedOptions = [];
  const quarterMonths = {
    "Jan - Dec": {
      1: ["JAN", "FEB", "MAR"],
      2: ["APR", "MAY", "JUN"],
      3: ["JUL", "AUG", "SEP"],
      4: ["OCT", "NOV", "DEC"],
    },
    "Apr - Mar": {
      1: ["APR", "MAY", "JUN"],
      2: ["JUL", "AUG", "SEP"],
      3: ["OCT", "NOV", "DEC"],
      4: ["JAN", "FEB", "MAR"],
    },
  };

  if (!selectedPlan || !selectedPlan.data) {
    return groupedOptions;
  }

  const planType = selectedPlan.data.sales_plan_type;
  const planPeriodType = selectedPlan.data.sales_plan_period_type;
  const planCalculation = selectedPlan.data.sales_plan_calculation;

  const startMonth = planPeriodType === "Jan - Dec" ? 1 : 4;

  for (let i = -pastYears; i <= futureYears; i++) {
    const year = currentYear + i;
    const label = i < 0 ? "Completed" : i === 0 ? "Current" : "Future";
    const options = [];

    if (planCalculation === "quarterly") {
      for (let j = 1; j <= 4; j++) {
        const months = quarterMonths[planPeriodType][j];
        const optionLabel = `Q${j} (${months.join(" - ")}) ${year}`;
        if (optionLabel !== selectedPlan.data.sales_plan_period) {
          options.push({ label: optionLabel, value: optionLabel });
        }
      }
    } else if (planCalculation === "monthly") {
      for (let j = startMonth; j <= 12; j++) {
        const optionLabel = `${getMonthName(j)} ${year}`;
        if (optionLabel !== selectedPlan.data.sales_plan_period) {
          options.push({ label: optionLabel, value: optionLabel });
        }
      }
      for (let j = 1; j < startMonth; j++) {
        const optionLabel = `${getMonthName(j)} ${year + 1}`;
        if (optionLabel !== selectedPlan.data.sales_plan_period) {
          options.push({ label: optionLabel, value: optionLabel });
        }
      }
    }

    if (options.length > 0) {
      groupedOptions.push({ label, options });
    }
  }

  return groupedOptions;
};

const SalesPlan = () => {
  const [showModal, setShowModal] = useState(false);
  const [showNextPeriodModal, setShowNextPeriodModal] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [nextPeriod, setNextPeriod] = useState("");
  const [nextPeriodTarget, setNextPeriodTarget] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { salesPlanData, deleteStatus } = useSelector((state) => state.salesPlan);
  const salesPlanMainData = useSelector(
    (state) => state.salesPlan.salesPlanMainData || []
  );
  const groupedSalesPlans = {};
  const { salesPlanData, deleteStatus, createStatus, updateStatus } =
    useSelector((state) => state.salesPlan);
  const currentCurrencyData = useSelector((state) => state?.currency)?.data?.[0];

  salesPlanData?.forEach((plan) => {
    const mainSalesPlanId = plan.data.main_sales_plan_id;
    if (!groupedSalesPlans[mainSalesPlanId]) {
      groupedSalesPlans[mainSalesPlanId] = [];
    }
    groupedSalesPlans[mainSalesPlanId].push(plan);
  });

  const yearOptions = [];
  for (let year = 2023; year <= 2026; year++) {
    yearOptions.push(year);
  }

  useEffect(() => {
    dispatch(getSalesPlanStart());
  }, [dispatch]);

  // useEffect(() => {
  //   if (deleteStatus === true) {
  //     dispatch(getSalesPlanStart());
  //   }
  // }, [deleteStatus, dispatch]);

  // ... other code ...
useEffect(() => {
  dispatch(getMainSalesPlanStart());
}, [dispatch]);
  useEffect(() => {
    if (
      deleteStatus === true ||
      createStatus === true ||
      updateStatus === true
    ) {
      dispatch(getSalesPlanStart());
    }
  }, [deleteStatus, createStatus, updateStatus, dispatch]);

  const toggleRow = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleConfirmDelete = () => {
    if (planToDelete) {
    const otherRecords = salesPlanData.filter((record) => record.data.main_sales_plan_id === planToDelete.data.main_sales_plan_id && record._id !== planToDelete._id);
    if (otherRecords.length > 0) {
      dispatch(deleteSalesPlanStart(planToDelete._id));
    } else {
      dispatch(deleteSalesPlanStart(planToDelete._id));
      dispatch(deleteMainSalesPlanStart(planToDelete.data.main_sales_plan_id));
    }

      setShowDeleteModal(false);
      setPlanToDelete(null);
    }
  };

  const handleDelete = (salesPlan) => {
    setPlanToDelete(salesPlan);
    setShowDeleteModal(true);
  };

  const handleEdit = (salesPlan) => {
    console.log("salesPlan._id from table", salesPlan._id);
    navigate("/digylax/form-module/target-tree", {
      state: {
        salesPlanId: salesPlan._id,
        isNewPlan: false,
        salesPlanData: {
          sales_plan_name: salesPlan.data?.sales_plan_name || "",
          sales_plan_period: salesPlan.data?.sales_plan_period || "",
          sales_plan_target:
            salesPlan.data?.sales_plan_target?.toString() || "0",
          sales_plan_option: salesPlan.data?.sales_plan_option || "existing",
          sales_plan_type: salesPlan.data?.sales_plan_type || "revenue_based",
          sales_plan_period_type:
            salesPlan.data?.sales_plan_period_type || "Jan - Dec",
          sales_plan_calculation:
            salesPlan.data?.sales_plan_calculation || "monthly",
          main_sales_plan_id:
            salesPlan.data?.main_sales_plan_id || salesPlan._id,
          target_data: salesPlan.data?.target_data || [],
          calculation_method: salesPlan.data?.calculation_method || "top-down",
        },
      },
    });
  };

  const handleViewHierarchy = (salesPlan) => {
    navigate("/digylax/form-module/target-achivement", {
      state: { salesPlanData: salesPlan },
    });
  };

  const handleCreateNextPeriod = (mainSalesPlanId) => {
    const salesPlan = salesPlanData.find(
      (plan) => plan.data.main_sales_plan_id === mainSalesPlanId
    );
    if (salesPlan) {
      setSelectedPlan(salesPlan);
      setNextPeriod("");
      setNextPeriodTarget(salesPlan.data?.sales_plan_target?.toString() || "");
      setShowNextPeriodModal(true);
    }
  };

  const handleNextPeriodModalClose = () => {
    setShowNextPeriodModal(false);
    setSelectedPlan(null);
    setNextPeriod("");
    setNextPeriodTarget("");
  };

  const handleNextPeriodSubmit = () => {
    if (selectedPlan && nextPeriod && nextPeriodTarget) {
      const targetValue = parseFloat(nextPeriodTarget);
      const newSalesPlan = {
        sales_plan_name: selectedPlan.data?.sales_plan_name || "",
        sales_plan_period: nextPeriod,
        sales_plan_target: targetValue,
        sales_plan_option: "existing",
        sales_plan_type: selectedPlan.data?.sales_plan_type || "revenue_based",
        sales_plan_period_type:
          selectedPlan.data?.sales_plan_period_type || "Jan - Dec",
        sales_plan_calculation:
          selectedPlan.data?.sales_plan_calculation || "monthly",
        main_sales_plan_id:
          selectedPlan.data?.main_sales_plan_id || selectedPlan._id,
        target_data: [],
        calculation_method: selectedPlan.data?.calculation_method || "top-down",
      };

      console.log("Navigating with newSalesPlan:", newSalesPlan);

      navigate("/digylax/form-module/target-tree", {
        state: {
          salesPlanId:
            selectedPlan.data?.main_sales_plan_id || selectedPlan._id,
          salesPlanData: newSalesPlan,
          isNewPlan: true,
        },
      });
      handleNextPeriodModalClose();
    } else {
      alert("Please select a period and enter a valid target.");
    }
  };

  const currencySymbol = Utils.currencySymbols(currentCurrencyData?.currency_code) || '$';

  const formatNumber = (value) => {
    if (value === "" || value == null) return `${currencySymbol}0`;
    const num = parseFloat(value);
    if (isNaN(num)) return `${currencySymbol}0`;
    return `${currencySymbol}${Math.floor(num).toLocaleString()}`;
  };

  const getTargetValue = (node) => {
    if (node.type === "user") {
      return formatNumber(node.child_value || "0");
    }
    if (node.type === "territory") {
      return formatNumber(node.target_value || "0");
    }
    return `${currencySymbol}0`;
  };

  const renderChildren = (children, parentId, level = 1) => {
    if (!children || !children.length) return null;

    return children.map((child) => {
      const [territoryName, managerName] = child.name
        .split(":")
        .map((str) => str.trim());
      return (
        <React.Fragment key={child.id}>
          <tr>
            <td
              style={{
                textAlign: "center",
                cursor: child.children?.length > 0 ? "pointer" : "default",
                position: "sticky",
                left: 0,
                background: "#fff",
                zIndex: 2,
              }}
              onClick={
                child.children?.length > 0
                  ? () => toggleRow(child.id)
                  : undefined
              }
            >
              {child.children?.length > 0
                ? expandedRows.includes(child.id)
                  ? "−"
                  : "+"
                : ""}
            </td>
            <td
              style={{
                position: "sticky",
                left: "40px",
                background: "#fff",
                zIndex: 1,
                paddingLeft: `${20 * level}px`,
              }}
            >
              {child.type === "territory" ? (
                <>
                  {territoryName} {managerName ? `- ${managerName}` : ""}
                </>
              ) : (
                child.name
              )}
            </td>
            <td>{getTargetValue(child)}</td>
            <td>{formatNumber(child.secondary_value || "0")}</td>
          </tr>
          {expandedRows.includes(child.id) &&
            renderChildren(child.children, child.id, level + 1)}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="container mt-4">
      <h6 className="mb-4">Sales Plans</h6>

      <div className="d-flex justify-content-end align-items-center mb-3 gap-2">
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          Create Sales Plan
        </button>
      </div>

      {Object.keys(groupedSalesPlans).length > 0 ? (
        Object.entries(groupedSalesPlans).map(([mainSalesPlanId, plans]) => {
          const firstPlan = plans[0]; // Use first plan for name
          return (
            <div key={mainSalesPlanId} className="mb-5">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6>
                  {firstPlan.data?.sales_plan_name || "Unnamed Plan"} Sales
                  Plans
                </h6>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => handleCreateNextPeriod(mainSalesPlanId)}
                  >
                    Create for Next Period
                  </button>
                </div>
              </div>

              <div
                className="table-wrapper border rounded"
                style={{
                  overflowX: "auto",
                  overflowY: "visible",
                  maxWidth: "150%",
                }}
              >
                <table
                  className="table table-bordered table-hover mb-0"
                  style={{
                    minWidth: "1200px",
                    borderCollapse: "collapse",
                    position: "relative",
                  }}
                >
                  <thead style={{ backgroundColor: "white", color: "black" }}>
                    <tr>
                      <th
                        style={{
                          position: "sticky",
                          top: 0,
                          left: 0,
                          zIndex: 3,
                          backgroundColor: "white",
                          width: "40px",
                        }}
                      ></th>
                      <th
                        style={{
                          position: "sticky",
                          top: 0,
                          left: "40px",
                          zIndex: 3,
                          backgroundColor: "white",
                          minWidth: "200px",
                        }}
                      >
                        Sales Plan Period
                      </th>
                      <th
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: "white",
                          minWidth: "150px",
                        }}
                      >
                        Self
                      </th>
                      <th
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: "white",
                          minWidth: "150px",
                        }}
                      >
                        Team
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {plans.map((salesPlan) => (
                      <React.Fragment key={salesPlan._id}>
                        <tr>
                          <td
                            style={{
                              textAlign: "center",
                              cursor:
                                salesPlan.data?.target_data?.length > 0
                                  ? "pointer"
                                  : "default",
                              position: "sticky",
                              left: 0,
                              background: "#fff",
                              zIndex: 2,
                              width: "40px",
                            }}
                            onClick={
                              salesPlan.data?.target_data?.length > 0
                                ? () => toggleRow(salesPlan._id)
                                : undefined
                            }
                          >
                            {salesPlan.data?.target_data?.length > 0
                              ? expandedRows.includes(salesPlan._id)
                                ? "−"
                                : "+"
                              : ""}
                          </td>
                          <td
                            style={{
                              position: "sticky",
                              left: "40px",
                              background: "#fff",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "center",
                              minWidth: "200px",
                            }}
                          >
                            <span>
                              {salesPlan.data?.sales_plan_period ||
                                "Unknown Period"}
                            </span>
                            <button
                              className="btn btn-sm"
                              style={{
                                marginLeft: "8px",
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleEdit(salesPlan)}
                            >
                              <i
                                className="fa fa-pencil"
                                style={{ color: "black" }}
                              ></i>
                            </button>
                            <button
                              className="btn btn-sm"
                              style={{
                                marginLeft: "8px",
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleDelete(salesPlan)}
                            >
                              <i
                                className="fa fa-trash"
                                style={{ color: "black" }}
                              ></i>
                            </button>
                            <button
                              className="btn btn-sm"
                              style={{
                                marginLeft: "8px",
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleViewHierarchy(salesPlan)}
                            >
                              <i
                                className="fa fa-eye"
                                style={{ color: "black" }}
                              ></i>
                            </button>
                          </td>
                          <td>{`${currencySymbol}0`}</td>
                          <td>
                            {formatNumber(
                              salesPlan.data?.sales_plan_target || "0"
                            )}
                          </td>
                        </tr>
                        {expandedRows.includes(salesPlan._id) &&
                          (salesPlan.data?.target_data?.length > 0 ? (
                            salesPlan.data.target_data.map((territory) => (
                              <React.Fragment key={territory.id}>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      cursor:
                                        territory.children?.length > 0
                                          ? "pointer"
                                          : "default",
                                      position: "sticky",
                                      left: "0px",
                                      background: "#fff",
                                      zIndex: 2,
                                      width: "40px",
                                    }}
                                    onClick={
                                      territory.children?.length > 0
                                        ? () => toggleRow(territory.id)
                                        : undefined
                                    }
                                  >
                                    {territory.children?.length > 0
                                      ? expandedRows.includes(territory.id)
                                        ? "−"
                                        : "+"
                                      : ""}
                                  </td>
                                  <td
                                    style={{
                                      position: "sticky",
                                      left: "40px",
                                      background: "#fff",
                                      zIndex: 1,
                                      paddingLeft: "20px",
                                      minWidth: "200px",
                                    }}
                                  >
                                    {territory.name.includes(":")
                                      ? `${territory.name
                                          .split(":")[0]
                                          .trim()} - ${territory.name
                                          .split(":")[1]
                                          .trim()}`
                                      : territory.name}
                                  </td>
                                  <td>{getTargetValue(territory)}</td>
                                  <td>
                                    {formatNumber(
                                      territory.secondary_value || "0"
                                    )}
                                  </td>
                                </tr>
                                {expandedRows.includes(territory.id) &&
                                  renderChildren(
                                    territory.children,
                                    territory.id,
                                    2
                                  )}
                              </React.Fragment>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4">No territory data available</td>
                            </tr>
                          ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })
      ) : (
        <p>No sales plans available.</p>
      )}

      <CreateSalesPlanModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />

      <Modal
        show={showNextPeriodModal}
        onHide={handleNextPeriodModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Next Period Sales Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Next Period</Form.Label>
              <Form.Select
                value={nextPeriod}
                onChange={(e) => setNextPeriod(e.target.value)}
              >
                <option value="">Select Period</option>
                {getOptions(
                  selectedPlan?.data?.sales_plan_type,
                  selectedPlan?.data?.sales_plan_period_type,
                  selectedPlan?.data?.sales_plan_calculation,
                  selectedPlan
                ).map((group, idx) => (
                  <optgroup key={idx} label={group.label}>
                    {group.options.map((opt, subIdx) => (
                      <option key={subIdx} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Target</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Sales Target"
                value={nextPeriodTarget}
                onChange={(e) =>
                  setNextPeriodTarget(e.target.value.replace(/[^0-9.]/g, ""))
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleNextPeriodModalClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleNextPeriodSubmit}
            disabled={!nextPeriod || !nextPeriodTarget}
          >
            Create
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        top
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this sales plan?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SalesPlan;
